import React, { PropsWithChildren } from 'react';

import { Typography } from '@mui/material';

import { secondary_text_color } from 'theme/cemTheme';

export function SecondaryText({ children }: PropsWithChildren) {
  return (
    <Typography variant="body2" sx={{ color: secondary_text_color }}>
      {children}
    </Typography>
  );
}
